// import { useContext } from 'react';
import { useContext } from 'use-context-selector';
import { ProductsContext } from 'Contexts/ProductsContext';

export default function useProducts() {
  return useContext(ProductsContext);
}
